export class AuthApiError extends Error {
    readonly code: string;
    customData?: Record<string, unknown> | undefined;

    constructor(code: string, message: string, customData?: Record<string, unknown> | undefined) {
        super(message);
        this.code = code;
        this.message = message;
        this.customData = customData;
    }
}
